const t = "_root_1phew_1", o = "_visible_1phew_17", n = "_textContainer_1phew_22", e = "_actionsContainer_1phew_28", i = {
  root: t,
  visible: o,
  textContainer: n,
  actionsContainer: e
};
export {
  e as actionsContainer,
  i as default,
  t as root,
  n as textContainer,
  o as visible
};
//# sourceMappingURL=index.es750.js.map
